import { useEffect } from "react";

const useAnalytics = () => {
    useEffect(() => {
        if (typeof window !== "undefined" && window.gtag) {
            window.gtag("event", "page_view", {
                page_path: window.location.pathname,
            });
        }
    }, [location]);
};

export default useAnalytics;
